export default function navigateToLeadPage(
  leadsLinkAddress: string,
  tokenId: string,
) {
  if (!leadsLinkAddress) return;

  const searchParams = new URLSearchParams(window.location.search);
  const advisorCode = searchParams.get("EA");
  const advisorCodeParam = advisorCode ? `&EA=${advisorCode}` : "";

  window.location.href = `${leadsLinkAddress}?installSource=digitalExperienceWeb&tokenId=${tokenId}${advisorCodeParam}`;
}
